import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { chain, UpdateSession } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";

import {
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        billToId?: string;
        shipToId?: string;
        fulfillmentMethod: string;
        pickUpWarehouse: WarehouseModel | null;
        isDefault?: boolean;
        returnUrl?: string;
        skipRedirect?: boolean;
    } & HasOnSuccess &
    HasOnError<string>,
    UpdateSessionApiParameter,
    Session,
    {
        cart: Cart;
    }
>;

export const UpdatePickUpWarehouseInCache: HandlerType = props => {
    const pickUpWarehouse = props.parameter.pickUpWarehouse;

    if (pickUpWarehouse && pickUpWarehouse !== undefined && pickUpWarehouse?.id !== "") {
        localStorage.setItem("selectedShipBranch", JSON.stringify(pickUpWarehouse));
    }
};

addToChainAfter(chain, UpdateSession, UpdatePickUpWarehouseInCache);
